<template>
  <div>
    <chat v-if="resource.chatRoomId" :resource="resource" />
  </div>
</template>

<script>
import chat from './Chat.vue'

export default {
  name: 'Station',
  components: {
    chat
  },
  data () {
    return {
      error: {},
      resource: {
        title: null,
        type: 'station',
        chatRoomId: null,
        image: null,
        resourceId: null
      }
    }
  },
  async mounted () {
    const resourceId = this.$route.params.id
    const url = `/stations/${resourceId}`
    try {
      const response = await this.axios.get(url)

      this.resource.title = response.data.title
      this.resource.chatRoomId = response.data.chat.id
      this.resource.image = response.data.detailViewImagery['2xImageURL']
      this.resource.chat_admin_id = response.data.chat.adminId
      this.resource.resourceId = resourceId
    } catch (error) {
      if (error.response.status === 401) {
        this.toast(error.response.data)
      }
    }
  },
  methods: {
    toast (message) {
      this.$bvToast.toast(`${message}`, {
        title: 'Error',
        solid: true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
